import globelVar from '@/globelVar.js'
import ybapis from '@/apis/ybApi.js'

export default {
    state: {
        sign_no:"",
        ybflag:"",
        ybjsflag:"",
        ybyjsflag:"",
        insutype:"",
        insuplc_admdvs:"",
        psn_type:"",
        emp_name:"",
        mdtrt_cert_type:"",
        mdtrt_cert_no:"",
        cardInfo:{},
        m1101Input:{},
        m1101Output:{},
        m2201Input:{},
        m2201Output:{},
        m2203Input:{},
        m2203Output:{},
        m2204Input:{},
        m2204Output:{},
        m2206Input:{},
        m2206Output:{},
        m2207Input:{},
        m2207Output:{},
        m5301Input:{},
        m5301Output:{},
        m5391Input:{},
        m5391Output:{},
        m2202Input:{},
        m2202Output:{},
        m2205Input:{},
        m2205Output:{},
        m2208Input:{},
        m2208Output:{},

        yb1001_input:{},
        yb1001_output:{},
        yb2001_input:{},
        yb2001_output:{}
    },
    actions: {
        changeSignNo:(context,para)=>{
            context.commit('SET_SIGNNO',para)
        },
        changeM1101Input:(context,para)=>{
            context.commit('changeM1101Input',para)
        },

        changeM1101Output:(context,para)=>{
            context.commit('changeM1101Output',para)
        },

        changeM2201Input:(context,para)=>{
            context.commit('changeM2201Input',para)
        },

        changeM2201Output:(context,para)=>{
            context.commit('changeM2201Output',para)
        },

        changeM2203Input:(context,para)=>{
            context.commit('changeM2203Input',para)
        },

        changeM2203Output:(context,para)=>{
            context.commit('changeM2203Output',para)
        },

        changeM2204Input:(context,para)=>{
            context.commit('changeM2204Input',para)
        },

        changeM2204Output:(context,para)=>{
            context.commit('changeM2204Output',para)
        },

        changeM2206Input:(context,para)=>{
            context.commit('changeM2206Input',para)
        },

        changeM2206Output:(context,para)=>{
            context.commit('changeM2206Output',para)
        },

        changeM2207Input:(context,para)=>{
            context.commit('changeM2207Input',para)
        },

        changeM2207Output:(context,para)=>{
            context.commit('changeM2207Output',para)
        },

        changeM5301Input:(context,para)=>{
            context.commit('changeM5301Input',para)
        },

        changeM5301Output:(context,para)=>{
            context.commit('changeM5301Output',para)
        },

        changeM5391Input:(context,para)=>{
            context.commit('changeM5391Input',para)
        },

        changeM5391Output:(context,para)=>{
            context.commit('changeM5391Output',para)
        },

        changeYbflag:(context,para)=>{
            context.commit('changeYbflag',para)
        },

        changeYbjsflag:(context,para)=>{
            context.commit('changeYbjsflag',para)
        },

        changeM2202Input:(context,para)=>{
            context.commit('changeM2202Input',para)
        },

        changeM2202Output:(context,para)=>{
            context.commit('changeM2202Output',para)
        },

        changeM2205Input:(context,para)=>{
            context.commit('changeM2205Input',para)
        },

        changeM2205Output:(context,para)=>{
            context.commit('changeM2205Output',para)
        },

        changeM2208Input:(context,para)=>{
            context.commit('changeM2208Input',para)
        },

        changeM2208Output:(context,para)=>{
            context.commit('changeM2208Output',para)
        },

        changeYbyjsflag:(context,para)=>{
            context.commit('changeYbyjsflag',para)
        },

        changeCardInfo:(context,para)=>{
            context.commit('changeCardInfo',para)
        },

        clearYbStore:(context)=>{
            context.commit('clearYbStore')
        },

        clearYbRegist:(context)=>{
            context.commit('clearYbRegist')
        },

        changeYb1001Input:(context,para)=>{
            context.commit('changeYb1001Input',para)
        },

        changeYb1001Output:(context,para)=>{
            context.commit('changeYb1001Output',para)
        },

        changeYb2001Input:(context,para)=>{
            context.commit('changeYb2001Input',para)
        },

        changeYb2001Output:(context,para)=>{
            context.commit('changeYb2001Output',para)
        },

        
    },
    mutations: {
        SET_SIGNNO:(state, para)=>{
            state.sign_no = para
        },

        changeM1101Input:(state,para)=>{
            state.m1101Input =   para  
        },

        changeM1101Output:(state,para)=>{
            state.m1101Output =   para  
            const insuinfoList = para.output.insuinfo
            console.log("1101",insuinfoList)
            for (let i = 0; i < insuinfoList.length; i++) {
                const insuinfo = insuinfoList[i];
                const insutype_tmp = insuinfo.insutype
                const paus_insu_date_tmp = insuinfo.paus_insu_date
                const psn_type_tmp = insuinfo.psn_type
                const emp_name =  insuinfo.emp_name

                const nowdate = globelVar.tools.getCurrentDate();
                if ((insutype_tmp == '310' || insutype_tmp == '390') && (paus_insu_date_tmp == null || paus_insu_date_tmp >= nowdate)) {
                    state.insutype = insutype_tmp
                    state.insuplc_admdvs = insuinfo.insuplc_admdvs
                    state.psn_type = psn_type_tmp
                    state.emp_name = emp_name
                }
                
            }
        },

        changeM2201Input:(state,para)=>{
            state.m2201Input =   para
        },

        changeM2201Output:(state,para)=>{
            state.m2201Output =   para  
        },

        changeM2203Input:(state,para)=>{
            state.m2203Input = para
        },

        changeM2203Output:(state,para)=>{
            state.m2203Output = para
        },

        changeM2204Input:(state,para)=>{
            state.m2204Input = para
        },

        changeM2204Output:(state,para)=>{
            state.m2204Output = para
        },

        changeM2206Input:(state,para)=>{
            state.m2206Input = para
        },

        changeM2206Output:(state,para)=>{
            state.m2206Output = para
            state.ybyjsflag = "1"
        },

        changeM2207Input:(state,para)=>{
            state.m2207Input = para
        },

        changeM2207Output:(state,para)=>{
            state.m2207Output = para
        },

        changeM5301Input:(state,para)=>{
            state.m5301Input = para
        },

        changeM5301Output:(state,para)=>{
            state.m5301Output = para
        },

        changeM5391Input:(state,para)=>{
            // console.log('5391',para)
            state.m5391Input = para
        },

        changeM5391Output:(state,para)=>{
            state.m5391Output = para
        },

        changeYbflag:(state,para)=>{
            console.log("ybflag",para)
            state.ybflag = para
        },

        changeYbjsflag:(state,para)=>{
            console.log("ybjsflag",para)
            state.ybjsflag = para
        },

        changeM2202Input:(state,para)=>{
            state.m2202Input =   para
        },

        changeM2202Output:(state,para)=>{
            state.m2202Output =   para  
        },

        changeM2205Input:(state,para)=>{
            state.m2205Input =   para
        },

        changeM2205Output:(state,para)=>{
            state.m2205Output =   para  
            state.ybyjsflag = ""
        },
        
        changeM2208Input:(state,para)=>{
            state.m2208Input =   para
        },

        changeM2208Output:(state,para)=>{
            state.m2208Output =   para  
        },

        changeYbyjsflag:(state,para)=>{
            state.ybyjsflag =   para  
        },

        changeYb1001Input:(state,para)=>{
            state.yb1001_input =   para  
        },

        changeYb1001Output:(state,para)=>{
            state.yb1001_output =   para  
        },

        changeYb2001Input:(state,para)=>{
            state.yb2001_input =   para  
        },

        changeYb2001Output:(state,para)=>{
            state.yb2001_output =   para
            state.ybjsflag = "1"  
        },

        changeCardInfo:(state,para)=>{
            state.cardInfo =   para 
            state.mdtrt_cert_type =  para.mdtrt_cert_type
            state.mdtrt_cert_no =  para.mdtrt_cert_no
            state.insuplc_admdvs =  para.admdvs
        },

        clearYbRegist:(state)=>{
            if (state.ybjsflag == "1") {
                ybapis.yb2004()
            }
        },

        clearYbStore:(state)=>{
            console.log("医保clearYbStore")
            // state.m9001Input={}
            // state.m9001Output={}
            if (state.ybjsflag == "1") {
                console.log("医保clearYbStore1")
                ybapis.yb2004().then(res => {
                    if(res == "1"){
                        state.ybflag=""
                        state.insutype=""
                        state.insuplc_admdvs=""
                        state.ybyjsflag = ""
                        state.ybjsflag = ""
                        state.psn_type = ""
                        state.emp_name = ""
                        state.mdtrt_cert_type =  ""
                        state.mdtrt_cert_no =  ""

                        state.cardInfo =   {} 
                        

                        state.m1101Input={}
                        state.m1101Output={}
                        state.m2201Input={}
                        state.m2201Output={}
                        state.m2203Input={}
                        state.m2203Output={}
                        state.m2204Input={}
                        state.m2204Output={}
                        state.m2206Input={}
                        state.m2206Output={}
                        state.m2207Input={}
                        state.m2207Output={}
                        state.m5301Input={}
                        state.m5301Output={}
                        state.m5391Input={}
                        state.m5391Output={}
        
                        state.m2202Input={}
                        state.m2202Output={}
                        state.m2205Input={}
                        state.m2205Output={}
                        state.m2208Input={}
                        state.m2208Output={} 
                        state.yb1001_input={}
                        state.yb1001_output={}
                        state.yb2001_input={}
                        state.yb2001_output={}
                    }
                    
                })
            } else {
                console.log("医保clearYbStore2")
                state.ybflag=""
                state.insutype=""
                state.insuplc_admdvs=""
                state.ybyjsflag = ""
                state.ybjsflag = ""
                state.psn_type = ""
                state.emp_name = ""
                state.mdtrt_cert_type =  ""
                state.mdtrt_cert_no =  ""

                state.cardInfo =   {} 

                state.m1101Input={}
                state.m1101Output={}
                state.m5301Input={}
                state.m5301Output={}
                state.m5391Input={}
                state.m5391Output={}

                state.m2201Input={}
                state.m2201Output={}
                state.m2203Input={}
                state.m2203Output={}
                state.m2204Input={}
                state.m2204Output={}
                state.m2206Input={}
                state.m2206Output={}
                state.m2207Input={}
                state.m2207Output={}

                state.m2202Input={}
                state.m2202Output={}
                state.m2205Input={}
                state.m2205Output={}
                state.m2208Input={}
                state.m2208Output={}
                state.yb1001_input={}
                state.yb1001_output={}
                state.yb2001_input={}
                state.yb2001_output={}
            }
            
        }
    }
}